// src/element-ui/index.js
// 1. 引入 Vue
import Vue from 'vue'

// 2. 按需引入需要的组件（修正菜单组件名称）
import {
  Button,
  Form,
  FormItem,
  Input,
  Checkbox,
  CheckboxGroup,
  Message,
  MessageBox,
  Table,
  TableColumn,
  Pagination,
  Icon,
  Dialog,
  Tabs,
  TabPane,
  Select,
  Option,
  Upload,
  Radio,
  RadioGroup,
  Card,
  Row,
  Col,
  Cascader,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  // 修正：去掉 El 前缀，使用官方标准名称
  Menu,
  MenuItem,
  Submenu,
  MenuItemGroup,
  DatePicker,
  TimePicker,
  ColorPicker,
  Collapse,
  CollapseItem,
  Empty,
  Tag,
  Tree,
  Divider,
  Popover,
  Tooltip,
  Loading,
  PageHeader,
  Progress,
  InputNumber,
  Slider,
  RadioButton,
  // 图片（人脸底图等图片预览）
  Image
} from 'element-ui'

// 3. 注册组件（全局可用，同步修正注册名）
Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Icon)
Vue.use(Dialog)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Select)
Vue.use(Option)
Vue.use(Upload)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Cascader)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(ColorPicker)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Empty)
Vue.use(Tag)
Vue.use(Tree)
Vue.use(Divider)
Vue.use(Tooltip)
// 修正：注册时使用去掉 El 前缀的名称
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(MenuItemGroup)
Vue.use(Popover)
Vue.use(Loading)
Vue.use(PageHeader)
Vue.use(Progress)
Vue.use(InputNumber)
Vue.use(Slider)
Vue.use(RadioButton)
Vue.use(Image)
// 4. 特殊：弹窗类组件挂载到 Vue 原型
Vue.prototype.$loading = Loading
Vue.prototype.$message = Message
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt


// WEBPACK FOOTER //
// ./src/element-ui/index.js